import appointmentRequestAPI from '../../api/appointment_request'

//  state
const state = {
  initiated: false,
  scheduledPreEmpAppointments: [],
  approvedPreEmpAppointments: [],
  rejectedPreEmpAppointments: [],
  furtherTestingPreEmpAppointments: [],
  scheduledTotalPages: 1,
  approvedTotalPages: 1,
  rejectedTotalPages: 1,
  furtherTestingTotalPages: 1,
  doctorComments: null
}

// getters
const getters = {
  getScheduledPreEmpAppointments () {
    return state.scheduledPreEmpAppointments
  },
  getApprovedPreEmpAppointments () {
    return state.approvedPreEmpAppointments
  },
  getRejectedPreEmpAppointments () {
    return state.rejectedPreEmpAppointments
  },
  getFurtherTestingPreEmpAppointments () {
    return state.furtherTestingPreEmpAppointments
  },
  getScheduledTotalPages () {
    return state.scheduledTotalPages
  },
  getApprovedTotalPages () {
    return state.approvedTotalPages
  },
  getRejectedTotalPages () {
    return state.rejectedTotalPages
  },
  getFurtherTestingTotalPages () {
    return state.furtherTestingTotalPages
  },
  getDoctorComments () {
    return state.doctorComments
  }
}

//  actions
const actions = {
  setPreEmpAppointments ({commit}, {status, page}) {
    return new Promise((resolve, reject) => {
      appointmentRequestAPI.fetch(status, page).then(response => {
        let preEmployeeAppointments = response.body.pre_employee_appointments
        let totalRecords = response.body.total_records
        let perPage = response.body.per_page
        let totalPages = Math.ceil(totalRecords / perPage)
        switch (status) {
          case 'scheduled':
            commit('setScheduledPreEmpAppointments', preEmployeeAppointments)
            commit('setScheduledTotalPages', totalPages)
            resolve(response)
            break
          case 'approved':
            commit('setApprovedPreEmpAppointments', preEmployeeAppointments)
            commit('setApprovedTotalPages', totalPages)
            resolve(response)
            break
          case 'rejected':
            commit('setRejectedPreEmpAppointments', preEmployeeAppointments)
            commit('setRejectedTotalPages', totalPages)
            resolve(response)
            break
          case 'further_testing':
            commit('setFurtherTestingPreEmpAppointments', preEmployeeAppointments)
            commit('setFurtherTestingTotalPages', totalPages)
            resolve(resolve)
            break
          default:
            console.log(status, page)
            console.log('default pre emp appointments')
            resolve({body: {}})
        }
      }).catch(error => {
        console.log(error, 'pre emp appointments')
        reject(error)
      })
    })
  },
  approve ({dispatch}, {id, doctorId}) {
    return new Promise((resolve, reject) => {
      appointmentRequestAPI.approve(id, doctorId).then(response => {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        resolve(response)
      }).catch(error => {
        console.log(error, 'approve')
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        reject(error)
      })
    })
  },
  reject ({dispatch}, {id, doctorId}) {
    return new Promise((resolve, reject) => {
      appointmentRequestAPI.reject(id, doctorId).then(response => {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        resolve(response)
      }).catch(error => {
        console.log(error, 'reject')
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        reject(error)
      })
    })
  },
  furtherTesting ({dispatch}, {id, doctorId}) {
    return new Promise((resolve, reject) => {
      appointmentRequestAPI.furtherTesting(id, doctorId).then(response => {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        resolve(response)
      }).catch(error => {
        console.log(error, 'further testing')
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        reject(error)
      })
    })
  },
  saveComment ({dispatch}, {id, comment, doctorId}) {
    return new Promise((resolve, reject) => {
      appointmentRequestAPI.saveComment(id, comment, doctorId).then(response => {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        resolve(response)
      }).catch(error => {
        console.log(error, 'save comment')
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        reject(error)
      })
    })
  },
  search ({dispatch}, {query}) {
    return new Promise((resolve, reject) => {
      appointmentRequestAPI.search(query).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

//  mutations
const mutations = {
  setScheduledPreEmpAppointments (state, scheduledPreEmpAppointments) {
    if (!state.initiated) state.initiated = true
    state.scheduledPreEmpAppointments = scheduledPreEmpAppointments
  },
  setApprovedPreEmpAppointments (state, approvedPreEmpAppointments) {
    state.approvedPreEmpAppointments = approvedPreEmpAppointments
  },
  setRejectedPreEmpAppointments (state, rejectedPreEmpAppointments) {
    state.rejectedPreEmpAppointments = rejectedPreEmpAppointments
  },
  setFurtherTestingPreEmpAppointments (state, furtherTestingPreEmpAppointments) {
    state.furtherTestingPreEmpAppointments = furtherTestingPreEmpAppointments
  },
  setDoctorComment (state, comment) {
    state.doctorComments = comment
  },
  setScheduledTotalPages (state, totalPages) {
    state.scheduledTotalPages = totalPages
  },
  setApprovedTotalPages (state, totalPages) {
    state.approvedTotalPages = totalPages
  },
  setRejectedTotalPages (state, totalPages) {
    state.rejectedTotalPages = totalPages
  },
  setFurtherTestingTotalPages (state, totalPages) {
    state.furtherTestingTotalPages = totalPages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/pre_emp_appointment_request.js